import { actions } from "../actions";
import { ListingSearchResult, TabViewEnum, TravelWalletOffer } from "redmond";
import {
  SELECT_HOME,
  SET_SELECTED_LISTING_ID,
  FETCH_VACATION_RENTAL_SHOP,
  SET_VACATION_RENTAL_SHOP_CALL_STATE_FAILED,
  SET_NOTIFY_IF_SHOP_AND_BOOK_PRICE_DIFFER_FLAG,
  SET_LISTING_CALENDAR,
  SET_TAB_VIEW,
  SET_SHOP_OFFER,
  SET_IS_BOOSTED,
  SET_LIFESTYLE_ELIGIBILITY,
  SET_LIST_PRICE,
} from "../actions/constants";
import {
  ListingId,
  Price,
  VacationRentalCalendarResponse,
} from "redmond/apis/tysons/vacation-rentals";

export interface IVacationRentalShopState {
  selectedHome: ListingSearchResult | null;
  selectedHomeCalendar?: VacationRentalCalendarResponse;
  vacationRentalListingId: ListingId | null;
  vacationRentalShopCallState: VacationRentalShopCallState;
  vacationRentalShopCallError?: VacationRentalShopCallError;
  vacationRentalNotifyIfShopAndBookPriceDiffer: boolean;
  tabView?: TabViewEnum;
  shopOffer?: TravelWalletOffer;
  isBoosted?: boolean;
  isLifestyleEligible: boolean | null;
  listPrice: Price | null | undefined;
}

export enum VacationRentalShopCallState {
  NotCalled = "NotCalled",
  InProcess = "InProcess",
  Success = "Success",
  Failed = "Failed",
  FailureAcknowledged = "FailureAcknowledged",
}

export enum VacationRentalShopCallError {
  NoAvailability = "NoAvailability",
  Unknown = "Unknown",
}

const initialState: IVacationRentalShopState = {
  selectedHome: null,
  vacationRentalListingId: null,
  vacationRentalShopCallState: VacationRentalShopCallState.NotCalled,
  vacationRentalShopCallError: undefined,
  vacationRentalNotifyIfShopAndBookPriceDiffer: true,
  tabView: undefined,
  isBoosted: undefined,
  isLifestyleEligible: null,
  listPrice: undefined,
};

export const reducer = (
  state: IVacationRentalShopState = initialState,
  action: actions.VacationRentalShopActions
): IVacationRentalShopState => {
  switch (action.type) {
    case FETCH_VACATION_RENTAL_SHOP:
      return {
        ...state,
        vacationRentalShopCallState: VacationRentalShopCallState.InProcess,
        listPrice: undefined,
      };
    case SELECT_HOME:
      return {
        ...state,
        selectedHome: action.home,
        vacationRentalShopCallState: VacationRentalShopCallState.Success,
      };
    case SET_LISTING_CALENDAR:
      return {
        ...state,
        selectedHomeCalendar: action.calendar,
      };
    case SET_SELECTED_LISTING_ID:
      return {
        ...state,
        vacationRentalListingId: action.id,
      };
    case SET_VACATION_RENTAL_SHOP_CALL_STATE_FAILED:
      return {
        ...state,
        vacationRentalShopCallState: VacationRentalShopCallState.Failed,
        vacationRentalShopCallError: action.vrShopCallError,
        listPrice: state.listPrice ?? null,
      };
    case SET_NOTIFY_IF_SHOP_AND_BOOK_PRICE_DIFFER_FLAG:
      return {
        ...state,
        vacationRentalNotifyIfShopAndBookPriceDiffer: action.notify,
      };
    case SET_TAB_VIEW:
      return {
        ...state,
        tabView: action.tabView,
      };
    case SET_SHOP_OFFER:
      return {
        ... state,
        shopOffer: action.offer,
      }
    case SET_IS_BOOSTED:
      return {
        ...state,
        isBoosted: action.isBoosted,
      };
    case SET_LIFESTYLE_ELIGIBILITY:
      return {
        ...state,
        isLifestyleEligible: action.isEligible,
      };
    case SET_LIST_PRICE:
      return {
        ...state,
        listPrice: action.listPrice,
      };
    default:
      return { ...state };
  }
};

export * from "./selectors";
